import React, { useEffect } from 'react';
import { InfoMessage, Loading } from '@fasstech/middle-design-system';
import { append, includes, isEmpty, isNil, map, propOr, unless } from 'ramda';
import { isNilOrEmpty, isNotNilOrEmpty } from '../../../../server/helpers/index.mjs';
import CompanyCard from './CompanyCard.jsx';

const CompaniesList = ({
  loading,
  companies,
  setCompanies,
  getMiddleText,
  setSelectedCompany,
  selectedCompany,
  onSearchCcns,
  noCompaniesFound,
  setCcns,
  setCcnOffer,
  form
}) => {
  if (loading) {
    return <Loading />;
  }

  if (isNil(companies)) {
    return;
  }

  if (noCompaniesFound) {
    return (
      <div className={'flex w-full justify-start'}>
        <InfoMessage iconName={'lightbulb'}>
          {getMiddleText('ENTREPRISE_RECH_ENTREPRISE_AUCUN_ETAB_LABEL')}
        </InfoMessage>
      </div>
    );
  }

  useEffect(() => {
    if (isNotNilOrEmpty(selectedCompany)) {
      const siret = propOr('', 'siret', selectedCompany);
      setCompanies(
        companies.filter((company) => !includes(siret, company.siret))
      );
    }
  }, [selectedCompany]);

  const handleUnselectCompany = () => {
    setCcns(null);
    form.setValue('company.ccnRef', null, {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: false
    });
    unless(isEmpty, (company) => {
      setCcnOffer(null);
      setCompanies(append(company));
      setSelectedCompany({});
    })(selectedCompany);
  };

  return (
    <>
      <div className={'flex w-full py-4 gap-4'}>
        <div className={'flex flex-col w-1/2'}>
          <p className={'font-bold text-lg my-2'}>
            {getMiddleText('ENTREPRISE_RECH_ENTREPRISE_LISTE_LABEL')}
          </p>
          <p>{getMiddleText('ENTREPRISE_RECH_ENTREPRISE_IDENTIFIEE_LABEL')}</p>
          <div className={'h-[500px] overflow-y-auto mb-4'}>
            {map((company) => {
              const { siret, name, addresses, legalForm } = company;
              return (
                <CompanyCard
                  key={siret}
                  keyCompany={siret}
                  getMiddleText={getMiddleText}
                  siret={siret}
                  onClick={() => {
                    if (isNilOrEmpty(selectedCompany)) {
                      setSelectedCompany(company);
                      onSearchCcns({ company });
                    }
                  }}
                  disabled={isNotNilOrEmpty(selectedCompany)}
                  name={name}
                  addresses={addresses}
                  legalForm={legalForm}
                  iconName={'circleAdd'}
                  dataTestId={`selectCompany-${siret}`}
                />
              );
            }, companies)}
          </div>
        </div>
        {/* https://fasstio.atlassian.net/browse/MIDDLE-1894
         <Button variant="outline">{getMiddleText('ENTREPRISE_AJOUT_MANUEL_BOUTON_LABEL')}</Button> */}
        {isNotNilOrEmpty(selectedCompany) && (
          <div className={'flex flex-col w-1/2'}>
            <p className={'font-bold text-lg mt-10'}>
              {getMiddleText('ENTREPRISE_RECH_ENTREPRISE_SELECTIONNEE_LABEL')}
            </p>
            <CompanyCard
              keyCompany={selectedCompany.siret}
              getMiddleText={getMiddleText}
              siret={selectedCompany.siret}
              onClick={handleUnselectCompany}
              name={selectedCompany.name}
              addresses={selectedCompany.addresses}
              legalForm={selectedCompany.legalForm}
              className={'bg-primary text-white'}
              iconName={'circleRemove'}
              dataTestId={`unSelectCompany-${selectedCompany.siret}`}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default CompaniesList;
